import React, { Component } from 'react';
import { Link } from 'react-router';

import OrganizationSelect from "../../components/OrganizationSelect";
import ApplicationStore from "../../stores/ApplicationStore";
class UpdateOTA extends Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired
  };

  constructor() {
    super();
    this.state = {
      application: {},
      ota: {
        showAddMeterTableSelect: false,
        form: {
          firmware: null,
          firmwareName: '10.8.0.1',
          upgradeFrequency: 923.200000,
          upgradeDataRate: 5,
          packetSendingRate: 1,
          OTATime: '2024-12-01 00:00:00'
        },
        //表格就显示10行
        tableRowCount: 10,
        addMetersPage: 1,
        addMetersCount: 0,
        addMetersPageCount: 0,
        addSearch: '',
        //左边的已经添加了要升级的节点
        addMeters:[],
        copyAddMeters: null,

        //剩余的总y页
        noAddMetersPageCount: 0,
        noAddMetersCount: 0,
        //可以添加的节点的当前页
        noAddMetersPage: 1,
        noAddSearch: '',
         //右边的还可以添加的升级的节点
        noAddMeters:[],
        copyNoAddMeters:null
      },
      extPath: "",
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.myRef = null;
  }

  componentWillMount() {
    ApplicationStore.getApplication(this.props.params.applicationID, (application) => {
      this.setState({
        application: application,
        extPath: (typeof application.appType !== 'undefined' && application.appType === 2) ? "/subMeter/list" : "",
      });

      ApplicationStore.getOTA(this.props.params.applicationID, (ota) => {
        this.setState({
          //这里把后台返回来的参数保存着
          ota: {
            ...this.state.ota,
            form: {
                ...this.state.ota.form,
                firmwareName: ota.firmwareName,
                upgradeFrequency: ota.upgradeFrequency,
                upgradeDataRate: ota.upgradeDataRate,
                packetSendingRate: ota.packetSendingRate,
                OTATime: ota.oTATime
            },
            addMetersPageCount:Math.ceil(ota.addMetersCount / this.state.ota.tableRowCount),
            addMeters: ota.addMeters,
            copyAddMeters: ota.addMeters,
            addMetersCount:ota.addMetersCount,
            noAddMetersPageCount: Math.ceil(ota.noAddMetersCount / this.state.ota.tableRowCount),
            noAddMeters: ota.noAddMeters,
            copyNoAddMeters: ota.noAddMeters,
            noAddMetersCount:ota.noAddMetersCount,
          }
        });
      });
    });
  }

  formatDate = (date) => {
    const pad = num => num.toString().padStart(2, '0');
    const year = date.getFullYear();
    const month = pad(date.getMonth() + 1);
    const day = pad(date.getDate());
    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());
    
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  onSubmit(e,application) {
    //准备参数
    e.preventDefault();

    if (!this.state.ota.form.firmwareName.trim()) { // trim() 去除前后空格
      alert("Firmware cannot be empty");
      return;
    }

    if (!this.state.ota.form.OTATime) {
      alert("OTA time cannot be empty");
      return;
    }

    if (this.state.ota.form.upgradeDataRate < 2 || this.state.ota.form.upgradeDataRate > 5) {
      alert("Upgrade Data Rate time must be between 2 and 5");
      return;
    }

    let req = {...this.state.ota.form, devEUIs: this.state.ota.copyAddMeters.map(r => r.devEUI)}
    if (req.OTATime) {
      const date = new Date(req.OTATime); // 解析 ISO 格式字符串
      if (!isNaN(date.getTime())) {
        req.OTATime = this.formatDate(date);
      }
    }

    req.packetSendingRate = Number(req.packetSendingRate)
    
    ApplicationStore.updateOTA(this.props.params.applicationID, req, (responseData) => {
      this.context.router.push('/organizations/'+application.organizationID+'/applications/'+application.id+this.state.extPath);
    });
  }

  handleFileChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();

    reader.onload = (event) => {
        // 将 Data URL 转换为字节数据
        const dataUrl = event.target.result;
        const base64 = dataUrl.split(',')[1];
        const binaryString = window.atob(base64);
        const bytes = [];

        for (let i = 0; i < binaryString.length; i++) {
            bytes.push(binaryString.charCodeAt(i))
        }

        this.setState({
            ota: {
                ...this.state.ota,
                form: {
                    ...this.state.ota.form,
                    firmware: bytes,
                    firmwareName: file.name
                }
            }
        });
    };

    reader.readAsDataURL(file);
  }

  handleInputChange = (e,dir) => {
    const { name, value } = e.target;
    //用这个值过滤
    switch (dir) {
      case 'left':
        const lSearchTerm = value.toLowerCase();
        const lArray = this.state.ota.copyAddMeters.filter(r => 
          r.devEUI.toLowerCase().includes(lSearchTerm) || 
          r.softwareVersion.toLowerCase().includes(lSearchTerm)
        );
        this.setState(prevState => ({
          ota: {
            ...prevState.ota,
            addMeters: lArray,
            addMetersCount: lArray.length,
            addMetersPage: 1,
            addSearch: lSearchTerm,
            addMetersPageCount: Math.ceil(lArray.length / this.state.ota.tableRowCount),
          }
        }));
        break;
      case 'right':
        const rSearchTerm = value.toLowerCase();
        const rArray = this.state.ota.copyNoAddMeters.filter(r => 
          r.devEUI.toLowerCase().includes(rSearchTerm) || 
          r.softwareVersion.toLowerCase().includes(rSearchTerm)
        );
        this.setState(prevState => ({
          ota: {
            ...prevState.ota,
            noAddMeters: rArray,
            noAddMetersCount: rArray.length,
            noAddMetersPage: 1,
            noAddSearch: rSearchTerm,
            noAddMetersPageCount: Math.ceil(rArray.length / this.state.ota.tableRowCount),
          }
        }));
        
        break;
    
      default:
        break;
    }
    this.setState(prevState => ({
      ota: {
        ...prevState.ota,
        form: {
          ...prevState.ota.form,
          [name]: value
        }
      }
    }));
  }

  handleCustomButtonClick = () => {
    const fileInput = document.getElementById('fileInput');
    fileInput.click();
  }

  //移动之后页码重新计算
  moveMeters = (dir) => {
    switch (dir) {
      case 'left':
        // 把右边选中的移到左边
        const selectedFromNoAdd = this.state.ota.copyNoAddMeters.filter(meter => meter.isSelected);
        const updatedNoAddMeters = this.state.ota.noAddMeters.filter(meter => !meter.isSelected);
        const updatedCopyNoAddMeters = this.state.ota.copyNoAddMeters.filter(meter => !meter.isSelected);
        for (let index = 0; index < selectedFromNoAdd.length; index++) {
          selectedFromNoAdd[index].isSelected = false;
        }
        const updatedAddMetersFromNoAdd = [...this.state.ota.addMeters, ...selectedFromNoAdd.filter(r =>  
          r.devEUI.toLowerCase().includes(this.state.ota.addSearch) || 
          r.softwareVersion.toLowerCase().includes(this.state.ota.addSearch))];
        const updatedCopyAddMetersFromNoAdd = [...this.state.ota.copyAddMeters, ...selectedFromNoAdd];
        
        this.setState(prevState => ({
          ota: {
            ...prevState.ota,
            addMeters: updatedAddMetersFromNoAdd,
            addMetersCount: updatedAddMetersFromNoAdd.length,
            addMetersPage: 1,
            addMetersPageCount: Math.ceil(updatedAddMetersFromNoAdd.length / this.state.ota.tableRowCount),
            copyAddMeters: updatedCopyAddMetersFromNoAdd,
            noAddMeters: updatedNoAddMeters,
            noAddMetersCount: updatedNoAddMeters.length,
            noAddMetersPage: 1,
            noAddMetersPageCount: Math.ceil(updatedNoAddMeters.length / this.state.ota.tableRowCount),
            copyNoAddMeters: updatedCopyNoAddMeters
          }
        }));
        break;
  
      case 'right':
        // 把左边选中的移到右边
        const selectedFromAdd = this.state.ota.copyAddMeters.filter(meter => meter.isSelected);
        const updatedAddMeters = this.state.ota.addMeters.filter(meter => !meter.isSelected);
        const updatedCopyAddMeters = this.state.ota.copyAddMeters.filter(meter => !meter.isSelected);
        for (let index = 0; index < selectedFromAdd.length; index++) {
          selectedFromAdd[index].isSelected = false;
        }
        const updatedNoAddMetersFromAdd = [...this.state.ota.noAddMeters, ...selectedFromAdd.filter(r =>  
          r.devEUI.toLowerCase().includes(this.state.ota.noAddSearch) || 
          r.softwareVersion.toLowerCase().includes(this.state.ota.noAddSearch))];
        const updatedCopyNoAddMetersFromNoAdd = [...this.state.ota.copyNoAddMeters, ...selectedFromAdd];
        this.setState(prevState => ({
          ota: {
            ...prevState.ota,
            addMeters: updatedAddMeters,
            addMetersCount: updatedAddMeters.length,
            addMetersPageCount: Math.ceil(updatedAddMeters.length / this.state.ota.tableRowCount),
            addMetersPage: 1,
            copyAddMeters: updatedCopyAddMeters,
            noAddMeters: updatedNoAddMetersFromAdd,
            noAddMetersCount: updatedNoAddMetersFromAdd.length,
            noAddMetersPageCount: Math.ceil(updatedNoAddMetersFromAdd.length / this.state.ota.tableRowCount),
            noAddMetersPage: 1,
            copyNoAddMeters: updatedCopyNoAddMetersFromNoAdd,
            showAddMeterTableSelect: false,
          }
        }));
        break;
  
      default:
        break;
    }
  }  

  handleShowAddMeterTableSelectButtonClick = () => {
    if (this,this.state.ota.showAddMeterTableSelect) {
      this.moveMeters('right')
    }else{
      this.setState(prevState => ({
        ota: {
          ...prevState.ota,
          showAddMeterTableSelect: !prevState.ota.showAddMeterTableSelect
        }
      }));
    }
  }
  //排序的
  addSortTh (array, key, label) {
    if (key === 'check') {
      array.push(<th>{label}</th>);
    }else{
      array.push(<th style={{ textAlign: 'center' }}>{label}</th>);
    }
  }

  //切换页码
  paginationChange(block,nowPage){
    if (nowPage < 1) {
      nowPage = 1
    }

    switch (block) {
      case 'right':
        if (nowPage > this.state.ota.noAddMetersPageCount){
          nowPage = this.state.ota.noAddMetersPageCount
        }
        //这里应该先去后台把数据拿回来，再进行更新操作
        this.setState(prevState => ({
          ota: {
            ...prevState.ota,
            noAddMetersPage: nowPage
          }
        }));
        break;
      case 'left':
        if (nowPage > this.state.ota.addMetersPageCount){
          nowPage = this.state.ota.addMetersPageCount
        }
        this.setState(prevState => ({
          ota: {
            ...prevState.ota,
            addMetersPage: nowPage
          }
        }));
        break;
      default:
        break;
    }
  }

  handleCheckboxChange = (event,dir) => {
    const { value, checked } = event.target;
    
    switch (dir) {
      case 'left':
        this.setState(prevState => ({
          ota: {
            ...prevState.ota,
            addMeters: prevState.ota.addMeters.map(meter =>
              meter.devEUI === value
                ? { ...meter, isSelected: checked }
                : meter
            ),
            copyAddMeters: prevState.ota.copyAddMeters.map(meter =>
              meter.devEUI === value
                ? { ...meter, isSelected: checked }
                : meter
            )
          }
        }));
        break;

      case 'right':
        this.setState(prevState => ({
          ota: {
            ...prevState.ota,
            noAddMeters: prevState.ota.noAddMeters.map(meter =>
              meter.devEUI === value
                ? { ...meter, isSelected: checked }
                : meter
            ),
            copyNoAddMeters: prevState.ota. copyNoAddMeters.map(meter =>
              meter.devEUI === value
                ? { ...meter, isSelected: checked }
                : meter
            )
          }
        }));
        break;
    
      default:
        break;
    }
    
  };

  render() {
    const { firmwareName, upgradeFrequency, upgradeDataRate, packetSendingRate, OTATime } = this.state.ota.form;
    /***************************************左边的table，加入升级计划的节点信息********************************************/
    this.thsLeft = [];
    if (this.state.ota.showAddMeterTableSelect) {
      this.addSortTh(this.thsLeft, "check", "")
    }
    this.addSortTh(this.thsLeft, "devEUI", "DevEUI")
    this.addSortTh(this.thsLeft, "softwareVersion", "Software Version")
    this.addSortTh(this.thsLeft, "lastUpdate", "Last Update")
    
    let NodeRowsLeft = []
    if (this.state.ota.addMetersCount > 0) {
      const leftStart = (this.state.ota.addMetersPage-1) * this.state.ota.tableRowCount;
      const leftEnd = this.state.ota.addMetersPage === this.state.ota.addMetersPageCount
        ? this.state.ota.addMetersCount
        : leftStart + this.state.ota.tableRowCount;
  
      const leftRows = this.state.ota.addMeters.slice(leftStart, leftEnd);
      
      NodeRowsLeft = leftRows.map((meter, i) =>
        <tr>
          {this.state.ota.showAddMeterTableSelect ? (
            <td>
              <input
                style={{ padding: 0 }} 
                type="checkbox" 
                id={`lMeter-${i}`} 
                value={meter.devEUI} 
                checked={meter.isSelected}  // 设置默认选中状态
                onChange={(event) => this.handleCheckboxChange(event, 'left')} 
              />
            </td>
          ) : null}
          <td style={{ textAlign: 'center' }}>{meter.devEUI}</td>
          <td style={{ textAlign: 'center' }}>{meter.softwareVersion}</td>
          <td style={{ textAlign: 'center' }}>{meter.lastUpdate}</td>
        </tr>
      );
    }

    /***************************************右边的table，没有加入升级计划的节点信息********************************************/
    this.thsRight = [];
    this.addSortTh(this.thsRight, "check", "")
    this.addSortTh(this.thsRight, "devEUI", "DevEUI")
    this.addSortTh(this.thsRight, "softwareVersion", "Software Version")
    this.addSortTh(this.thsRight, "lastUpdate", "Last Update")

    let NodeRowsRight = []
    if (this.state.ota.noAddMetersCount > 0) {
      const rightStart = (this.state.ota.noAddMetersPage - 1) * this.state.ota.tableRowCount;
      const rightEnd = this.state.ota.noAddMetersPage === this.state.ota.noAddMetersPageCount
        ? this.state.ota.noAddMetersCount
        : rightStart + this.state.ota.tableRowCount;

      const rightRows = this.state.ota.noAddMeters.slice(rightStart, rightEnd);
      NodeRowsRight = rightRows.map((meter, i) =>
        <tr>
          <td>
            <input
              style={{padding: 0}} 
              type="checkbox" 
              id={`rMeter-${i}`} 
              value={meter.devEUI} 
              checked={meter.isSelected}  // 设置默认选中状态
              onChange={(event) => this.handleCheckboxChange(event, 'right')} 
            />
          </td>
          <td style={{ textAlign: 'center' }}>{meter.devEUI}</td>
          <td style={{ textAlign: 'center' }}>{meter.softwareVersion}</td>
          <td style={{ textAlign: 'center' }}>{meter.lastUpdate}</td>
        </tr>
      );
    }
    

    const PaginationBlock = (block,pageCount,page) => {
      if (!pageCount || pageCount < 2) {
        return
      }else if (pageCount < 11) {
        const arr = []
        for (let index = 0; index < pageCount; index++) {
          arr.push(<li className={index+1 === page ? 'active' : ''} onClick={() => this.paginationChange(block,index+1)}><a>{index+1}</a></li>)
        }
        return arr
      }else{
        //总页数大于10，这个时候应该就显示
        //首先把加减按钮加上
        const arr = []
        arr.push(<li onClick={() => this.paginationChange(block,1)}><a aria-label="Previous">&laquo;</a></li>)
        arr.push(<li onClick={() => this.paginationChange(block,page-1)}><a aria-label="Previous">&lt;</a></li>)
        //这里最多显示5个按钮，就当前页和他的前后左右四个一共5个
        if (page<4) {
          //就显示12345
          for (let index = 0; index < 5; index++) {
            arr.push(<li className={index+1 === page ? 'active' : ''} onClick={() => this.paginationChange(block,index+1)}><a>{index+1}</a></li>)
          }
          arr.push(<li><a>...</a></li>)
        }else if(pageCount - page < 4){
          //就显示最后5个
          arr.push(<li><a>...</a></li>)
          for (let index = pageCount - 5; index < pageCount; index++) {
            arr.push(<li className={index+1 === page ? 'active' : ''} onClick={() => this.paginationChange(block,index+1)}><a>{index+1}</a></li>)
          }
        }else{
          arr.push(<li><a>...</a></li>)
          //显示当前页为中心的5个
          for (let index = page - 3; index < page + 2; index++) {
            arr.push(<li className={index+1 === page ? 'active' : ''} onClick={() => this.paginationChange(block,index+1)}><a>{index+1}</a></li>)
          }
          arr.push(<li><a>...</a></li>)
        }
        arr.push(<li onClick={() => this.paginationChange(block,page+1)}><a aria-label="Next">&gt;</a></li>)
        arr.push(<li onClick={() => this.paginationChange(block,pageCount)}><a aria-label="Next">&raquo;</a></li>)
        return arr
      }
    }

    return(
      <div>
        <ol className="breadcrumb">
          <li><Link to="/organizations">Organizations</Link></li>
          <li><OrganizationSelect organizationID={this.props.params.organizationID} /></li>
          <li><Link to={`/organizations/${this.props.params.organizationID}/applications`}>Applications</Link></li>
          <li><Link to={`/organizations/${this.props.params.organizationID}/applications/${this.props.params.applicationID}${this.state.extPath}`}>{this.state.application.name}</Link></li>
          <li className="active">OTA</li>
        </ol>
        <hr />
        <div className="panel panel-default">
          <div className="panel-body">
            {/* 注意这里必须用箭头函数来调用，否则组件加载的时候就会执行 */}
            {/* <button className="btn btn-default btn-primary btn-success btn-info btn-warning" onClick={() => this.onSubmit(this.state.application)}>SUBMIT</button> */}
            <div className='ota'>
              <form onSubmit={(e) => this.onSubmit(e,this.state.application)}>
                <div className="form-row">
                  <div className="form-group col-md-5">
                    <label htmlFor="fileInput">Firmware:</label>
                    <input
                      type="text"
                      className="form-control"
                      value={firmwareName}
                      readOnly
                      onClick={() => this.handleCustomButtonClick()}
                    />
                    <input
                      type="file"
                      id="fileInput"
                      ref={node => this.myRef = node}
                      style={{ display: 'none' }}
                      onChange={this.handleFileChange}
                    />
                    <small className="text-muted">Please select firmware image</small>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-md-offset-2 col-md-5">
                    <label htmlFor="upgradeFrequency">Upgrade Frequency:</label>
                    <input type="text" className="form-control" id="upgradeFrequency" name="upgradeFrequency" required pattern="^(?:[0-9]|([1-9][0-9]*))(\.\d+)?$" value={upgradeFrequency} onChange={this.handleInputChange} />
                    <small className="text-muted">Enter the upgrade frequency point, unit is MHz</small>
                  </div>
                  <div className="form-group col-md-5">
                    <label htmlFor="upgradeDataRate">Upgrade Data Rate:</label>
                    <input type="text" className="form-control" id="upgradeDataRate" name="upgradeDataRate" required pattern="^(2|3|4|5)$" value={upgradeDataRate} onChange={this.handleInputChange} />
                    <small className="text-muted">Enter a number between 2 and 5.</small>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-md-offset-2 col-md-5">
                    <label htmlFor="otaTime">OTA Time:</label>
                    <input type="datetime-local" className="form-control" id="otaTime" name="OTATime" value={OTATime} onChange={this.handleInputChange} />
                    <small className="text-muted">Select the upgrade time in YYYY-MM-DDTHH:MM format</small>
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="col-md-12">
                    <div className="form-row">
                    <div className="form-group col-md-5" style={{padding: 0}}>
                    <label className="control-label" htmlFor="packetSendingRate">Packet Sending Rate</label>
                    <select className="form-control" id="packetSendingRate" name="packetSendingRate" required value={packetSendingRate} onChange={this.handleInputChange}>
                      <option key="0" value="0">1 packet / 2 seconds</option>
                      <option key="1" value="1">1 packet / second</option>
                      <option key="2" value="2">2 packets / second</option>
                      <option key="3" value="3">4 packets / second</option>
                    </select>
                  </div>
                    </div>
                  </div>
                </div>
                
                <div className="form-row">
                  <div className="form-group col-md-5 meters">
                    <h5>OTA Nodes</h5>
                    <div style={{width: '100%',display: 'flex',justifyContent: 'space-between', alignItems: 'center'}}>
                      <input type="text" placeholder='Input key to search' onChange={(e) => this.handleInputChange(e,'left')}/>
                      <button type="button" className="btn btn-primary moveBotton" onClick={this.handleShowAddMeterTableSelectButtonClick}> {this.state.ota.showAddMeterTableSelect ?  'Move':  'Remove'}</button>
                    </div>
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          {this.thsLeft}
                        </tr>
                      </thead>
                      <tbody>
                        {NodeRowsLeft}
                      </tbody>
                    </table>
                    <div className='pull-right'>
                      <ul className="pagination" >
                        {PaginationBlock('left',this.state.ota.addMetersPageCount,this.state.ota.addMetersPage)}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group col-md-2">
                    <div className='center'>
                      <button type="button" className="custom-button" onClick={() => this.moveMeters('left')}>
                        <i className="glyphicon glyphicon-arrow-left custom-icon" ></i>
                      </button>
                    </div>
                    <div className='center'>
                      <button type="button" className="custom-button" onClick={() => this.moveMeters('right')}>
                        <i className="glyphicon glyphicon-arrow-right custom-icon"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="form-group  col-md-5 meters">
                    <h5>Non-OTA Nodes</h5>
                    <input type="text" placeholder='Input key to search' onChange={(e) => this.handleInputChange(e,'right')} />
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          {this.thsRight}
                        </tr>
                      </thead>
                      <tbody>
                        {NodeRowsRight}
                      </tbody>
                    </table>
                    <div className='pull-right'>
                      <ul className="pagination" >
                        {PaginationBlock('right',this.state.ota.noAddMetersPageCount,this.state.ota.noAddMetersPage)}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="form-row">
                  <div className="col-md-12">
                    <button type="submit" className="btn btn-primary">Submit</button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default UpdateOTA;



// WEBPACK FOOTER //
// ./src/views/applications/OTA.js